export default "__VITE_ASSET__e0d6c2cf__"